import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { cloudfrontPath } from '@utils/image'
type Props = {
  heading: string
}

export const SummaryProgramHeading = ({ heading }: Props): JSX.Element => (
  <div className="flex flex-row items-center">
    <div className="w-[3.2vw] lg:w-[0.9vw]">
      <ImageWraper
        src={`${cloudfrontPath}/programs/icons/program-detail/heading_icon.svg`}
        width={12}
        height={12}
      />
    </div>
    <div className="ml-[2.3vw] lg:ml-[0.6vw]">
      <div className="text-[4.3vw] lg:text-[1.3vw] font-bold">
        <h3>{heading}</h3>
      </div>
    </div>
  </div>
)
